import React, { useState } from "react";
import { Box, Divider, Typography } from '@mui/material';
import FormularioBlog from "../pages/Blog/FormularioBlog";
import ListaBlog from "../pages/Blog/ListaBlog";
import FormularioInfoBlog from "../pages/Blog/FormularioInfoBlog";
import ListaInfoBlog from "../pages/Blog/ListaInfoBlog";
import BlogPages from "../pages/Blog/BlogPages";

const DashboardBlogWebWeb = () => {
    const [blogSeleccionado, setBlogSeleccionado] = useState(null);
    const [infoBlogSeleccionado, setInfoBlogSeleccionado] = useState(null);
    
    // Función para manejar la edición del blog
    const handleEditarBlog = (blog) => {
        setBlogSeleccionado(blog);
        console.log('Estoy en DashboardBlog ' + blog);
    };

    // Función para manejar la edición del infoBlog
    const handleEditarInfoBlog = (infoblog) => {
        setInfoBlogSeleccionado(infoblog);
        console.log('Estoy en DashboardBlog ' + infoblog);
    };

    return(
        <Box sx={{
            gap: '20px',
            margin: '10px 5px',
            textAlign: 'center',
            '@media (max-width: 600px)': {  // En móviles
                flexDirection: 'column', // Asegurarse que esté en columna
                width: '95%',
                gap: '20px',
                margin: '1% 5%',
            },
        }}>
            <Typography 
                variant='h5' 
                sx={{ 
                    width: 'auto',
                    alignItems: 'center',
                    textAlign: 'center',
                    '@media (max-width: 600px)': {  // Ajustes para móviles
                        fontSize: '1.25rem',  // Tamaño más pequeño para la tipografía
                        margin: '1% 5%',
                    },
                }}
            >
                Sección Nuestro blog
            </Typography>

            <Divider 
                sx={{
                    backgroundColor: '#8E0505',
                    width: '100%', // El ancho se ajusta a todo el espacio disponible
                    height: '0%',  // Puede ajustar el grosor aquí, aunque este valor es 0
                    margin: '1% 0%',
                    borderWidth: '0.1px',
                }} 
            />
            <Box sx={{ 
                display: 'flex', 
                flexDirection: 'column', // En pantallas pequeñas, columna, en otras también columna
                gap: '20px',
                margin: '3% 0%',
            }}>
                

                {/* Agregar blog */}
                {<FormularioBlog blogSeleccionado={blogSeleccionado}/>}

                {/* lista de blogs */}
                <ListaBlog onEditar={handleEditarBlog}/>

            </Box>

            <Typography 
                variant='h5' 
                sx={{ 
                    width: 'auto',
                    alignItems: 'center',
                    textAlign: 'center',
                    '@media (max-width: 600px)': {  // Ajustes para móviles
                        fontSize: '1.25rem',  // Tamaño más pequeño para la tipografía
                        margin: '1% 5%',
                    },
                }}
            >
                Sección de la información de Nuestro blog
            </Typography>

            <Divider 
                sx={{
                    backgroundColor: '#8E0505',
                    width: '100%', // El ancho se ajusta a todo el espacio disponible
                    height: '0%',  // Puede ajustar el grosor aquí, aunque este valor es 0
                    margin: '1% 0%',
                    borderWidth: '0.1px',
                }} 
            />
            
            <Box sx={{ 
                display: 'flex', 
                flexDirection: 'column', // En pantallas pequeñas, columna, en otras también columna
                gap: '20px',
                margin: '3% 0%',
            }}>

                {/*Formulario para agregar el contenido a la página web */}
                <FormularioInfoBlog infoBlogSeleccionado={infoBlogSeleccionado}/>

                {/*Lista de la informació que se muestra en la pagina de handleEditarInfoBlog*/}
                <ListaInfoBlog onEditar={handleEditarInfoBlog} />
            </Box>
            <BlogPages/>
        
        </Box>
    );
}

export default DashboardBlogWebWeb;